import { Platform, StyleSheet } from 'react-native';
import { brand, buttons, neutrals, text } from 'src/theme/colors';

export const styles = StyleSheet.create({
  button: {
    borderColor: 'transparent',
    borderWidth: 2,
  },
  buttonMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 4,
    //flex: 1,
  },
  buttonInnerMobile: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
  },
  buttonDesktop: {
    minWidth: 166,
    borderRadius: 16,
    paddingHorizontal: 24,
    paddingVertical: 14,
  },
  buttonInnerDesktop: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonHover: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonPressed: {},
  buttonFocus: {
    borderColor: brand.main.variations['lighterWater-1'],
    backgroundColor: 'none',
  },
  buttonDisabled: {},
  buttonSelected: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  text: { fontWeight: 400, fontSize: 18, color: text.secondaryText },
  textMobile: { fontWeight: 700, fontSize: 12, color: text.secondaryText },
  textHover: {
    color: text.secondaryText,
  },
  textPressed: {
    color: brand.main.variations['darkerWater-1'],
  },
  textFocus: {
    color: text.secondaryText,
  },
  textDisabled: {
    color: neutrals.neutralGrays.aluminium,
  },
  textSelected: {
    color: brand.main.variations['darkerWater-1'],
  },
  picker: {
    color: buttons.tertiary.buttonTertiaryIconDefault,
  },
  pickerHover: {
    color: buttons.tertiary.buttonTertiaryIconDefault,
  },
  pickerPressed: {
    color: brand.main.variations['darkerWater-1'],
  },
  pickerFocus: {
    color: buttons.tertiary.buttonTertiaryIconDefault,
  },
  pickerDisabled: {
    color: neutrals.neutralGrays.aluminium,
  },
  pickerSelected: {
    color: brand.main.variations['darkerWater-1'],
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: -44, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
